
import Vue, { defineComponent, ref, getCurrentInstance, onMounted, computed } from 'vue';
import { formateNum, getQuery } from '@/common/utils';
import { PwaBridge } from '~/common/bridge';

export default defineComponent({
    components: {},
    props: {
        imgSrc: {
            type: String,
            // required: true,
            default: 'https://cdn-static.ap4r.com/kos/s101/nlav11312/kos/s101/nlav11312/pwa/common/logo/kwai_128.png',
        },
        likeCount: {
            type: Number,
            required: true,
            default: 0,
        },
        photoId: {
            type: String,
            required: true,
        },
        kwaiId: {
            type: String,
            required: true,
        },
        profileUserTop: {
            type: Boolean,
            required: false,
        },
    },
    setup(props, ctx) {
        const { proxy } = getCurrentInstance() as { proxy: Vue };
        const origin = ref('');
        const query = getQuery();

        const jumpLink = computed(() => {
            return `/@${props.kwaiId}/video/${props.photoId}`;
        });

        const handleClick = async () => {
            const url = `${window?.location?.origin}${jumpLink.value}${window?.location?.search}`;

            if (proxy?.$isAppEnvironment) {
                PwaBridge.openWebview({
                    url,
                });
                return;
            }

            window.open(url, '_blank');
        };

        onMounted(() => {
            origin.value = window.location.origin;
        });

        return {
            origin,
            proxy,
            formateNum,
            handleClick,
            jumpLink,
        };
    },
});
